<template>
	<li class="list-group-item px-2 py-0">
		<div class="border-start">
			<div class="d-flex ms-n2 pb-2">
				<div class="flex-none me-3">
					<div class="icon icon-shape text-sm rounded-circle" :class="statusInfo?.class" style="width: 15px; height: 15px;"></div>
				</div>
				<div class="vstack pt-1">
					<div class="h5 fw-bold">
						{{ statusInfo?.title ?? history.status }}
						<span class="text-sm text-muted fw-normal" v-if="extras">{{ extras }}</span>
					</div>
					<div class="text-sm text-break text-white-space lh-xs" v-if="history.observations">{{ history.observations }}</div>
					<div class="text-xs text-muted">{{ dateDiff }}</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
	import { computed, inject } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			history: Object
		},
		setup(props) {
			const $env = inject('$env');
			const dateDiff = moment(props.history.created_at).fromNow();

			const statusInfo = computed(() => {
				if(props.history.status in $env.MODEL.CustomerUser.statuses) return $env.MODEL.CustomerUser.statuses[props.history.status];
				else return null;
			});

			const extras = computed(() => {
				let info = [];

				switch(props.history.status) {
					case 'contacted':
						if('type' in (props.history.extras ?? [])) switch(props.history.extras.type) {
							case 'phone':
								info.push('por teléfono');
								break;
							case 'email':
								info.push('por email');
								break;
						}

						if('option' in (props.history.extras ?? [])) switch(props.history.extras.option) {
							case 'call':
								info.push('(llamada)');
								break;
							case 'whatsapp':
								info.push('(whatsapp)');
								break;
						}
						break;
					case 'purchased':
						if('reconquest' in (props.history.extras ?? []) && props.history.extras.reconquest) {
							info.push('reconquistado');
						}
						break;
				}

				return info.join(' ');
			});

			return { dateDiff, statusInfo, extras };
		}
	}
</script>